import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const PartnerWithUsHub = lazy(() => import("@/pages/PartnerWithUsHub"));

export const Route = createFileRoute("/_public/partner-with-us")({
  component: PartnerWithUsHub,
});
